import authProvider from '../../core/AuthenticationProvider'
import { Button } from '../common/html/button'
import { localStorageKeys } from '../utils/common'
import classes from './ErrorCommon.module.scss'

export const Logout = () => {
  const handleLogout = () => {
    localStorage.setItem(localStorageKeys.KEY_LOGOUT, true)
    authProvider.signout()
  }

  return (
    <Button
      isI18n
      className={classes.logoutBtn}
      label={'error.SIGN_OUT'}
      style={{ backgroundColor: '#2C73E8', color: '#FFFFFF' }}
      action={handleLogout}
    />
  )
}
